module.exports = __webpack_public_path__ + "static/media/chengwei22.19fea954.png";